import * as UIUtil from "/app/js/util/UI.js";
import * as Menu from "/app/js/common/Menu.js";
import * as CommonUtil from "/app/js/util/Common.js";

/**
 * 단순조회 또는 간단한 기능을 하는 서브페이지 클래스
 * 상세한 기능이 있다면 별도 클래스를 구성해야한다.
 * @param menuKey
 * @returns {Promise<void>}
 */
export const open = async function (menuKey) {
    const parentKey = Menu.getParentKey(menuKey);
    const htmlUrl = `app/html/${document.documentElement.lang}/aboutus/Contact.html`;
    // .headerWrap의 다음에 htmlUrl를 fetch하여 삽입한다.
    try {
        const response = await fetch(htmlUrl);
        const text = await response.text();
        const headerWrap = document.querySelector(".headerWrap");
        await headerWrap.insertAdjacentHTML('afterend', text);
        initMap();
        initEvt();
    } catch (error) {
        console.error('HTML 로딩 중 오류 발생:', error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리하도록 함
    }
}

function initEvt() {
    const homeElement = document.querySelector('.breadcrumb .home');
    const parentElement = document.querySelectorAll('.breadcrumb li a')[1]; // 두 번째 항목: ABOUT US 등

    if (homeElement) {
        homeElement.addEventListener('click', () => {
            Menu.openMenu('Main');
        });
    }

    if (parentElement) {
        parentElement.addEventListener('click', () => {
            const currentMenuKey = Menu.getActiveMenuKey();
            const parentKey = Menu.getParentKey(currentMenuKey);
            const firstChildKey = Menu.getKeyMenuByParent(parentKey);
            if (firstChildKey) {
                Menu.openMenu(firstChildKey);
            }
        });
    }
}


function initMap() {
    new daum.roughmap.Lander({
        "timestamp" : "1742372202558",
        "key" : "2nec4",
        "mapWidth" : "100%",
        "mapHeight" : "100%"
    }).render();

    new daum.roughmap.Lander({
        "timestamp" : "1742372255809",
        "key" : "2nec6",
        "mapWidth" : "100%",
        "mapHeight" : "100%"
    }).render();

    new daum.roughmap.Lander({
        "timestamp" : "1742372365508",
        "key" : "2nec8",
        "mapWidth" : "100%",
        "mapHeight" : "100%"
    }).render();
}